import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormValidatorHelper } from '@newroom-connect/library/helpers';
import { TranslatePipe } from '@newroom-connect/library/pipes';

import { ButtonComponent } from '../../../buttons/button/button.component';
import { InputPasswordComponent } from '../../../inputs/input-password/input-password.component';
import { InputTextComponent } from '../../../inputs/input-text/input-text.component';
import { PasswordFormatValidatorComponent } from '../../../password-format-validator/password-format-validator.component';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputPasswordComponent,
    InputTextComponent,
    PasswordFormatValidatorComponent,
    TranslatePipe
  ],
  selector: 'nrc-sign-up-form-login',
  templateUrl: './sign-up-form-login.component.html'
})
export class SignUpFormLoginComponent {
  @Output() public continueEvent = new EventEmitter<{ email: string, password: string }>();

  public isSubmitted = false;
  public signUpLoginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, FormValidatorHelper.passwordStrength()])
  });

  /**
   * Emit continue event with the current sign up login form value.
   */
  @HostListener('document:keyup.enter')
  public continue(): void {
    this.isSubmitted = true;

    if (this.signUpLoginForm.valid && this.hasValidCredentials(this.signUpLoginForm.value)) {
      this.continueEvent.emit(this.signUpLoginForm.value);
    }
  }

  /**
   * Simple type guard that validates the form value has both email and password defined.
   *
   * @param value
   * @returns True if both email and password are defined as non-empty strings.
   */
  private hasValidCredentials(value: Partial<{ email: string | null, password: string | null }>): value is { email: string, password: string } {
    return typeof value.email === 'string'
      && value.email.length > 0
      && typeof value.password === 'string'
      && value.password.length > 0;
  }
}
